<template>
  <div id="box8">
    <div class="box">
      <div class="statement">活动声明</div>
      <div class="txt">
        <li>
          活动回馈形式多样，请注意活动规则，如有疑问请咨询在线老师；
        </li>
        <li>
          参与活动后若发生退费、弄虚作假，将取消活动资格，所得优惠及奖品作废；
        </li>
        <li>活动最终解释权归博学谷所有。</li>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang='scss' scoped>
.box {
  margin-top: 60px;
  .statement {
    text-align: center;
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 4px;
    color: #ffffff;
  }
  .txt {
    // margin: 0 auto;
    margin-left: 100px;
    max-width: 616px;
    height: 300px;
    margin-top: 29px;
    li {
      float: left;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 1px;
      color: #ffffff;
      line-height: 40px;
      list-style: none;
      &:nth-child(1)::before {
        content: "1.";
        margin-left: -40px;
        margin-right: 10px;
      }
      &:nth-child(2)::before {
        content: "2.";
        margin-left: -40px;
        margin-right: 10px;
      }
      &:nth-child(3)::before {
        content: "3.";
        margin-left: -40px;
        margin-right: 16px;
      }
    }
    &::after {
      content: "";
      display: inline-block;
      clear: both;
    }
  }
  background-image: url("../assets/cloud.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom center;
}
</style>